exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    width: 100%;\n    height: 100%;\n}\n\n#sidebar {\n    width: 250px;\n    position: fixed;\n    top: 0;\n    left: 0;\n    height: 100vh;\n    z-index: 999;\n    background: #7386D5;\n    color: #fff;\n    -webkit-transition: all 0.3s;\n    transition: all 0.3s;\n}\n\n.container-height {\n    height: 80px;\n}\n\n.box {\n    -webkit-transition: -webkit-box-shadow .3s;\n    transition: -webkit-box-shadow .3s;\n    transition: box-shadow .3s;\n    transition: box-shadow .3s, -webkit-box-shadow .3s;\n    border-radius: 10px;\n    border: 1px solid #ccc;\n}\n\n.box:hover {\n    -webkit-box-shadow: 0 0 31px rgba(33, 33, 33, .2);\n            box-shadow: 0 0 31px rgba(33, 33, 33, .2);\n}\n\na.firms {\n    font-family: \"Roboto\", sans-serif;\n    font-size: 15px;\n    color: black;\n    font-weight: bold;\n    text-decoration: none;\n}\n\na.firmalar {\n    font-family: \"Roboto\", sans-serif;\n    font-size: 15px;\n    color: #a5a4bf;\n}\n\n.max-height {\n    max-height: 25vh;\n    overflow-y: scroll;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/firms/firms.component.css
// module id = ../../../../../src/app/firms/firms.component.css
// module chunks = main